import Loader from "@/components/common/ui/loader";
import { getDefaultLayout } from "@/components/v2/layout/default-layout";
import { useOrgAndSiteContext } from "@/context";
import { ILayoutPage, V2_DEFAULT_LAYOUT_TYPE } from "@/types/layout";
import { getStoredSelectedTeam, storeSelectedTeam } from "@/utils/common";
import { useRouter } from "next/router";
import { useEffect } from "react";

const V2Home: ILayoutPage = () => {
  const { state } = useOrgAndSiteContext();
  const router = useRouter();

  useEffect(() => {
    if (state.type === "no_need_team") {
      const lastSeenTeamSlugId = getStoredSelectedTeam();
      if (
        lastSeenTeamSlugId &&
        state.organizations.find((org) => org.slug === lastSeenTeamSlugId)
      ) {
        router.replace(`/v2/${lastSeenTeamSlugId}`);
        return;
      }
      const firstTeam = state.organizations[0];
      if (firstTeam) {
        router.replace(`/v2/${firstTeam.slug}`);
        storeSelectedTeam(firstTeam);
        return;
      }

      router.replace("/v2/welcome");
    }
  }, [router, state]);

  return <Loader size="large" />;
};

V2Home.getLayout = getDefaultLayout(V2_DEFAULT_LAYOUT_TYPE.DEFAULT);
export default V2Home;
